//@ts-check
import React from 'react';
import Loader from '../Loader';
import apiClient from '../../data';
import JobFinished from './JobFinished';
import DocumentsView from './DocumentsView';
import OutputDownloaded from './OutputDownloaded';
/**
 * @param {import('./types').JobDetailsProps} props
 */

var JobDetails = function JobDetails(props) {
  var job = props.job,
      workspace = props.workspace,
      project = props.project,
      toolbar = props.toolbar,
      variant = props.variant;
  var onJobUpdated = props.onJobUpdated;
  var stage = job.Stage;
  var runAction = project.RunAction;
  var refreshTimer = null;
  React.useEffect(function () {
    var addTimeout = function addTimeout() {
      clearTimeout(refreshTimer);
      if (stage !== 'Starting' && stage !== 'Processing') return;
      refreshTimer = setTimeout(function () {
        apiClient.getJobById(job.Id, workspace).then(function (jobSummary) {
          onJobUpdated && onJobUpdated(jobSummary);
          addTimeout();
        });
      }, 2000);
    };

    if (stage === 'Starting' || stage === 'Processing') {
      addTimeout();
    }

    return function () {
      refreshTimer && clearTimeout(refreshTimer);
    };
  }, [stage]);
  if (stage === 'Starting') return React.createElement(Loader, null, "Starting");
  if (runAction && runAction.toLowerCase() === 'showmessage') return React.createElement(JobFinished, {
    job: job,
    project: project,
    toolbar: toolbar
  });
  if (stage === 'WaitingForTask' || stage === 'WaitingForSignature') return React.createElement(JobFinished, {
    job: job,
    project: project,
    toolbar: toolbar,
    message: stage === 'WaitingForTask' ? 'Pending approval' : 'Pending Signature'
  });
  if (runAction && runAction.toLowerCase() === 'downloadoutput') return React.createElement(OutputDownloaded, {
    project: project,
    job: job
  });
  return React.createElement(DocumentsView, {
    job: job,
    project: project,
    toolbar: toolbar,
    variant: variant
  });
};

export default JobDetails;